import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import * as React from 'react'

import styles from './Image.module.scss'
import { IImageProps } from './Image.types'

const Image = ({ alt, className, image }: IImageProps) => {
  if (typeof image === 'string') {
    return <img className={className ?? styles.image} src={image} alt={alt} />
  }

  const imageData = getImage(image || null)
  if (imageData) {
    return <GatsbyImage image={imageData} className={className} alt={alt || ''} />
  }

  if (image?.publicURL) {
    return <img src={image.publicURL} className={className ?? styles.image} alt={alt} />
  }
  return null
}

export default Image
